<template>
    <div class="dtp-container mm-datepicker" v-show="showModal">
        <div class="dtp" @click.prevent="showModal = false"></div>
        <div class="dtp-content mmDatepicker" >
            <div class="dtp-header text-center">
                <span>{{nameDay}}</span>
                <a href="#" @click.prevent="showModal = false"><i class="ms-Icon ms-Icon--ChromeClose"></i></a>
            </div>
            <div class="dtp-date text-center">
                <a href="#" @click.prevent="navigateMonth(-1)"><i class="ms-Icon ms-Icon--ChevronLeft"></i></a>
                <div class="text-uppercase">{{monthName}}</div>
                <div><b>{{day}}</b></div>
                <div>{{year}}</div>
                <a href="#" @click.prevent="navigateMonth(1)"><i class="ms-Icon ms-Icon--ChevronRight"></i></a>
            </div>
            <b-calendar v-model="fecha" hide-header start-weekday="1" @selected="selectDay" @context="onContext"></b-calendar>
        </div>
    </div>
</template>

<script>
    import { BCalendar } from 'bootstrap-vue'
    import moment from 'moment'
    export default {
        name: 'Datepicker',
        components: {
            BCalendar
        },
        data() {
            return {
                fecha: '',
                day: 0,
                year: 0,
                nameDay: '',
                monthName: '',
                showModal: false,
                idOpened: ''
            }
        },
        methods: {
            navigateMonth(value) {
                let f = moment(this.fecha, 'YYYY-MM-DD', true);
                this.fecha = f.add(value, 'months').format('YYYY-MM-DD');
            },
            onContext(ctx) {
                this.monthName = document.getElementsByClassName('b-calendar-grid-caption')[0].innerText
                this.nameDay = ctx.activeFormatted.split(',')[0];
                let f = moment(ctx.selectedYMD, 'YYYY-MM-DD', true);
                this.day = f.format('DD');
                this.year = f.format('YYYY');
                this.monthName = f.lang('es').format('MMMM').substring(0, 3);
            },
            openModal(value, id) {
                let f = moment(value, 'DD/MM/YYYY', true);
                this.fecha = f.isValid() ? f.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                this.showModal = true;
                this.idOpened = id;
            },
            selectDay(value) {
                this.showModal = false;
                let f = moment(value, 'YYYY-MM-DD', true);
                this.$emit('select', f.format('DD/MM/YYYY'), this.idOpened);
            }
        }
    }
</script>

<style>
.dtp-container, .dtp {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.dtp-container {
    z-index: 2000;
}
.dtp {
    background: rgba(0,0,0,.4);
    font-size: 15px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.dtp-content {
    background: #fff;
    max-width: 300px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
    max-height: 520px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.dtp-header {
    background-color: #0062ae!important;
    color: #fff;
    padding: 5px;
    position: relative;
}
.dtp-header a {
    position: absolute;
    right: 10px;
    color: #fff;
}
.dtp-date {
    background-color: var(--primary-color);
    color: #fff;
    font-size: 25px;
    padding: 15px 10px;
    line-height: 30px;
    position: relative;
}
.dtp-date b {
    font-size: 36px;
}
.dtp-date a {
    position: absolute;
    color: #fff;
    font-size: 44px;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
}
.dtp-date a:first-child {
    right: initial;
    left: 5px;
}
.mm-datepicker .b-calendar-nav, .mmDatepicker footer {
    display: none!important;
}
.mm-datepicker .b-calendar-grid-caption {
    padding: 22px;
}
</style>